import React from 'react';
import { NavLink, Route, Switch } from 'react-router-dom';
import { observer } from "mobx-react";
import { resolve } from "inversify-react";
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import soundFile from "../utils/effect-start-deal.mp3";

import OTCIndex from "./otc/OTCIndex";
import OTCMyAds from "./otc/OTCMyAds";
import OTCDealsTab from "./otc/OTCDealsTab";
import OTCChatsTab from "./otc/OTCChatsTab";
import OTCDeal from "./otc/OTCDeal";
import { AuthStore } from "../stores";
import { toast } from 'react-toastify';

interface IOTCPageProps {
    t: any;
    audioRef: typeof Audio;
}

interface IOTCPageState {
}


const ToastStartDeal = ({ deal_id, toastId }: { deal_id: number; toastId: string }) => {
    const handleClick = () => {
        toast.dismiss(toastId); // Закрываем уведомление при переходе
    };

    return (
        <>
            С вами начали сделку.
            <Link className="toast-start-deal-link" to={`/p2p/deals/${deal_id}`} onClick={handleClick}>
                Перейти в сделку
            </Link>
        </>
    );
};

@observer
class OTCPage extends React.Component<IOTCPageProps, IOTCPageState> {
    @resolve(AuthStore)
    declare protected readonly authStore: AuthStore;

    constructor(props) {
        super(props);
        this.audioRef = new Audio(soundFile);
    }

    componentDidMount(): void {
        if (!this.authStore.websocket) return
        this.authStore.websocket.addEventListener('message', this.onMessage);
    }

    componentWillUnmount() {
        if (!this.authStore.websocket) return
        this.authStore.websocket.removeEventListener('message', this.onMessage);
    }

    onMessage = (e: MessageEvent) => {
        const data = JSON.parse(e.data);
        if (data.action === 'deal_started') {
            this.audioRef.play();
            toast.success(<ToastStartDeal deal_id={data.deal_id} toastId="toast-start-deal" />, {
                autoClose: false, // Отключаем авто-закрытие
                toastId: "toast-start-deal", // Уникальный ID тоста
            });
        }
    }

    render() {
        const { t } = this.props;
        return (
            <main className="main">
                <section className="otc-section">
                    <div className="container">
                        <div className="tabs">
                            <ul className="tabs__list tabs__list--otc">
                                <NavLink exact to='/p2p' className="tabs__item">P2P</NavLink>
                                <NavLink to='/p2p/ads' className="tabs__item">{t('otc.tabs.my-invitation')}</NavLink>
                                <NavLink to='/p2p/deals' className={`tabs__item ${this.authStore.unreadMessages > 0 && 'tabs__item--active-message'}`}>{t('otc.tabs.my-trades')}</NavLink>
                                <NavLink to='/p2p/chats' className="tabs__item">{t('otc.tabs.my-chat')}</NavLink>
                            </ul>
                            <Switch>
                                <Route exact path='/p2p' component={OTCIndex} />
                                <Route path='/p2p/ads' component={OTCMyAds} />
                                <Route exact path='/p2p/deals' component={OTCDealsTab} />
                                <Route path='/p2p/deals/:did' component={OTCDeal} />
                                <Route path='/p2p/chats' component={OTCChatsTab} />
                                <Route path='/p2p/chats/:cid' component={OTCChatsTab} />
                            </Switch>
                        </div>
                    </div>
                </section>
            </main>
        )
    }
}

export default withTranslation()(OTCPage);
